import type { TProductDataRegions } from '@atlassian/search-client';

import type { PrimaryProductKey } from '../../../common/constants/products';
import type { BootstrapVariables } from '../../../common/constants/relay/types';
import { serveRegionSteeringExperiment } from '../../../common/utils/experiments';

export function getEdgeRegionHint(
	primaryProduct: PrimaryProductKey,
	productDataRegions: TProductDataRegions,
) {
	const primaryProductDataRegion = primaryProduct
		? productDataRegions[primaryProduct]?.[0]
		: undefined;
	const confluenceDataRegion = productDataRegions['confluence']?.[0];
	const jiraDataRegion = productDataRegions['jira']?.[0];
	const firstDataRegion = Object.entries(productDataRegions)[0]?.[0];

	return primaryProductDataRegion ?? confluenceDataRegion ?? jiraDataRegion ?? firstDataRegion;
}

export function getRelayFetchOptions(bootstrap: BootstrapVariables) {
	if (serveRegionSteeringExperiment()) {
		const edgeRegionHint =
			bootstrap.primaryProduct && bootstrap.productDataRegions
				? getEdgeRegionHint(bootstrap.primaryProduct, bootstrap.productDataRegions)
				: undefined;

		return {
			networkCacheConfig: {
				metadata: {
					headers: {
						'atl-edge-region-hint': edgeRegionHint,
					},
				},
			},
		};
	} else {
		return undefined;
	}
}
